import { Neo } from "@singularsystems/neo-react";
import { NeoReport, Report, ReportUIRenderer, ReportUIRendererProps } from "@singularsystems/neo-reporting";
import { ReportCategory } from "../../Reports/ReportCategory";
import PRNCriteria, { PRNExportType } from "./PRNCriteria";
import { ComponentType } from "react";
import { AppService, Types } from "../../../App/Services/AppService";
import { EnumHelper, FileUtils } from "@singularsystems/neo-core";

@NeoReport("PRNExport", { category: ReportCategory.Exports })
export default class PRNReport extends Report<PRNCriteria> {

    constructor() {
        super(PRNCriteria);
    }

    public renderCriteria() {
        return <div>
            <Neo.GridLayout md={2}>
                <div>
                    <Neo.FormGroup bind={this.criteria.meta.runDate} />
                    <Neo.FormGroup bind={this.criteria.meta.exportType} select={{ items: EnumHelper.asList(PRNExportType)}} />
                </div>
            </Neo.GridLayout>
        </div>;
    }

    get uiRenderer(): ComponentType<ReportUIRendererProps> {
        return PRNReportUIRenderer;
    }
}

class PRNReportUIRenderer extends ReportUIRenderer {
    
    renderActionButtons(): React.ReactNode {
        
        return <>
            {super.renderActionButtons()}
            <Neo.Button
                icon="file"
                variant="secondary"
                onClick={() => this.downloadFile()}>
                    Download File
            </Neo.Button>
        </>
    }

    private async downloadFile() {
        const apiClient = AppService.get(Types.Domain.ApiClients.ExportApiClient);

        const response = await this.props.taskRunner.waitFor(apiClient.getPRNFile((this.report as PRNReport).criteria.toJSObject()), {allowPost: true});

        FileUtils.showSaveFile(response);
    }
}